import {
  changeProcessShareFlag,
  compareTableData,
  isEmptyProcessWindowList,
} from '@/vue-caas/utils/process';

import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.companyApiUrl;

const companyStoreModule = {
  // namespaced: false,

  state: {
    companies: [],
    companiesForSetup: [],
    companiesSource: [],
    company: {},
    companyId: '',
    duplicate: {},
    apicompanies: [],
    agents: [],
    agentDBList: [],
    companyAdapterList: [],
    agentAdapterListAll: [],
    companyChange: {},
  },
  mutations: {
    SET_STORE_COMP_LIST(state, companies) {
      if (
        JSON.stringify(state.companiesSource) !== JSON.stringify(companies) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('COMP');
      }
      state.companies = companies === '' ? [] : companies;
      state.companiesSource = companies === '' ? [] : companies;
      state.company = {};
    },
    SET_STORE_COMP(state, company) {
      state.company = company;
    },
    SET_STORE_COMP_ID(state, id) {
      state.companyId = id;
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('COMP');
      }
    },
    SET_STORE_COMPANY_ADAPTER_LIST(state, companyAdapterList) {
      let companyList = [];
      let agentList = [];
      for (let i = 0; i < companyAdapterList.length; i += 1) {
        if (companyAdapterList[i].agentCnt > 0) {
          let tmp1 = { text: companyAdapterList[i].compNm, value: companyAdapterList[i].compId };
          companyAdapterList[i].agentList.forEach((element) => {
            let tmp2 = { text: element.agentNm, value: element.agentId };
            agentList.push(tmp2);
          });
          companyList.push(tmp1);
        }
      }
      state.companyAdapterList = companyList;
      state.agentAdapterListAll = agentList;
    },
    SET_STORE_DUP_CHECK(state, duplicate) {
      state.duplicate = duplicate;
    },
    SET_STORE_API_COMP_LIST(state, apicompanies) {
      state.apicompanies = apicompanies === '' ? [] : apicompanies;
    },
    SET_STORE_COMP_LIST_SETUP(state, companiesForSetup) {
      state.companyChange = compareTableData(state.companiesForSetup, companiesForSetup, 'compId');
      state.companiesForSetup = companiesForSetup;
    },
    SET_STORE_COMP_LIST_Update(state, str) {
      let datarows = state.companiesSource;
      let listResult = [];
      // if (str.trim().length < 3) {
      //   listResult = datarows;
      // } else {
      listResult = datarows.filter((item) => {
        if (
          item.compNm
            .toString()
            .toLowerCase()
            .includes(str.value.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      // }

      let index = listResult.findIndex((e) => e.ownrId.indexOf(str.ownr) !== -1);
      if (index > 0) {
        let temp = listResult[0];
        listResult[0] = listResult[index];
        listResult[index] = temp;
      }

      state.companies = listResult;
    },
    SET_STORE_AGENT_LIST(state, agents) {
      state.agents = agents === '' ? [] : agents;
    },
    SET_STORE_AGENT_DB_LIST(state, agentDBList) {
      state.agentDBList = agentDBList === '' ? [] : agentDBList;
    },
  },
  actions: {
    getCompanyList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/list`, params);
        commit('SET_STORE_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_COMP_LIST', []);
        throw err;
      }
    },
    getCompanyListSetup: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/setup/list`, params);
        commit('SET_STORE_COMP_LIST_SETUP', response.data);
        commit('SET_STORE_COMPANY_ADAPTER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_COMP_LIST_SETUP', []);
        commit('SET_STORE_COMPANY_ADAPTER_LIST', []);
        throw err;
      }
    },
    getCompany: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/company/${params.id}`);
        commit('SET_STORE_COMP', response.data);
      } catch (err) {
        commit('SET_STORE_COMP', {});
        throw err;
      }
    },
    updateCompany: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/update`, params);
        commit('SET_STORE_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_COMP_LIST', []);
        throw err;
      }
    },
    updateCompanyFromProcSetup: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/update`, params);
        commit('SET_STORE_COMP_ID', response.data);
      } catch (err) {
        throw err;
      }
    },
    insertCompany: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/insert`, params);
        commit('SET_STORE_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_COMP_LIST', []);
        throw err;
      }
    },
    deleteCompany: async ({ commit }, params) => {
      try {
        // alert(`${baseURI}/company/delete/${params.ownrId}/${params.compId}`);
        const response = await axios.post(
          `${baseURI}/company/delete/${params.ownrId}/${params.compId}`
        );
        commit('SET_STORE_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_COMP_LIST', []);
        throw err;
      }
    },
    checkCompany: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/check`, params);
        commit('SET_STORE_DUP_CHECK', response.data);
      } catch (err) {
        commit('SET_STORE_DUP_CHECK', {});
        throw err;
      }
    },
    checkEmailCompany: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/checkEmail`, params);
        return response.data;
      } catch (err) {
        commit('SET_STORE_DUP_CHECK', {});
        throw err;
      }
    },
    getApiCompanyList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/api/company/list`, params);
        commit('SET_STORE_API_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_API_COMP_LIST', []);
        throw err;
      }
    },
    getCompanyMngList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/company/manage/list`, params);
        commit('SET_STORE_API_COMP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_API_COMP_LIST', []);
        throw err;
      }
    },
    getAgentList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/agent/list`, params);
        commit('SET_STORE_AGENT_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_LIST', []);
        throw err;
      }
    },
    getAgentListAll: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/agent/all`);
        commit('SET_STORE_AGENT_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_LIST', []);
        throw err;
      }
    },
    getAgentDBList: async ({ commit }, params) => {
      try {
        const response = await axios.get(
          `${baseURI}/agent/dbList/${params.agentId}/${params.target_agent_id}`
        );
        commit('SET_STORE_AGENT_DB_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_DB_LIST', []);
        throw err;
      }
    },
    deleteAgent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/agent/delete`, params);
        commit('SET_STORE_AGENT_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_LIST', []);
        throw err;
      }
    },
    insertAgent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/agent/insert`, params);
        commit('SET_STORE_AGENT_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_LIST', []);
        throw err;
      }
    },
    updateAgent: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/agent/update`, params);
        commit('SET_STORE_AGENT_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_LIST', []);
        throw err;
      }
    },
  },
  getters: {
    companies: (state) => state.companies,
    companiesSource: (state) => state.companiesSource,
    company: (state) => state.company,
    companyId: (state) => state.companyId,
    duplicate: (state) => state.duplicate,
    apicompanies: (state) => state.apicompanies,
    companiesForSetup: (state) => state.companiesForSetup,
    agents: (state) => state.agents,
    agentDBList: (state) => state.agentDBList,
    companyAdapterList: (state) => state.companyAdapterList,
    agentAdapterListAll: (state) => state.agentAdapterListAll,
    companyChange: (state) => state.companyChange,
  },
};

export default companyStoreModule;
